import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';

import { PageLoader } from 'components/PageLoader';
import { messageSchema } from 'utils/validators';

import { clientMessageReply, getMessageThread } from './api';

import { MessageThreadScene } from './scene';

const replySchema = z.object({ reply: messageSchema });
type ReplyFormValues = z.infer<typeof replySchema>;

export default function MessageThread() {
  const { viewToken } = useParams<{ viewToken: string }>();
  const [data, setData] = useState<Kudable.MessageThreadData | null>(null);
  const [error, setError] = useState<string | null>(null);

  const form = useForm<ReplyFormValues>({
    resolver: zodResolver(replySchema),
    mode: 'onBlur',
    defaultValues: { reply: '' },
  });

  const load = () => {
    if (!viewToken) return;
    getMessageThread(viewToken)
      .then((res) => setData(res.data))
      .catch(() => setError('This conversation could not be found.'));
  };

  useEffect(load, [viewToken]);

  const handleSendReply = (values: ReplyFormValues) => {
    if (!viewToken) return;
    return clientMessageReply(viewToken, values.reply.trim())
      .then(() => {
        form.reset({ reply: '' });
        load();
      })
      .catch(() => setError('Could not send reply.'));
  };

  if (error)
    return <div style={{ padding: 32, textAlign: 'center' }}>{error}</div>;
  if (!data) return <PageLoader fullPage />;

  return (
    <MessageThreadScene
      thread={data.thread}
      form={form}
      onSendReply={handleSendReply}
    />
  );
}
